import React from 'react';
import {  Form, Input, Button,message, Table, Descriptions, Divider, Pagination, Empty} from 'antd';
import { dbFields } from '../../model/search/column';
import { dbFields as deviceFields}  from '../../model/device/column';
import { getDeviceByImei } from '../../model/device/requests';
import { getBatteryEventByImei } from '../../model/battery_event/requests';
import storage from '../../utils/storage';
import { configs } from '../../config/config';

class SearchItem extends React.Component {
    formRef = React.createRef();
    constructor(props){
        super(props);
        this.state = {
            data:[],
            batteryList:[]
        };

        this.columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
           },
            {
                title: 'IMEI',
                dataIndex: 'imei',
                key: 'imei',
           },
           {
            title: 'Customer ID',
            dataIndex: 'custom_id',
            key: 'custom_id',
         },
         {
            title: 'DevosId',
            dataIndex: 'devos_id',
            key: 'devos_id',
         },
         {
            title: 'LowRemind',
            dataIndex: 'low_remind_time',
            key: 'low_remind_time',
         },
         {
            title: 'OffRemind',
            dataIndex: 'off_remind_time',
            key: 'off_remind_time',
         },
        ]
    };

    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }


    handlerSubmit = (e) => {
       let imei =  this.formRef.current.getFieldValue(dbFields.imei.key);
       getDeviceByImei({imei:imei}).then(res=>{
           if(res.data.code === 200){
            let  data = res.data.data
               this.setState({
                   data:data
               })
           }else{
               message.error(res.data.msg)
               if(res.data.code === 20001 || res.data.code === 20002){
                this.props.history.push("/")
               }
           }
           
       }).catch(err=>{
           message.error(err)
       })

       let batteryList = []
       getBatteryEventByImei({imei:imei}).then(res=>{
           if(res.data.code === 200 ){
                batteryList = res.data.data
                this.setState({
                    batteryList:batteryList
                })
           }
       }).catch(err=>{
            message.error(err)
       })
    }
    render(){
        let {data,batteryList} = this.state;
    
        let total = this.state.batteryList.length;
        return (
            <>
                <Form ref={this.formRef}>
                    <Form.Item
                          name={dbFields.imei.key}
                          label={dbFields.imei.title}
                    >
                         <Input />
                    </Form.Item>

                    <Form.Item>
                            <Button 
                            type="primary"
                            style={{background: "#851dd6" }}
                            onClick={this.handlerSubmit}
                             >
                                Check
                            </Button>
                    </Form.Item>    
                </Form>

                {Object.keys(data).length  ? (
                    <Descriptions bordered title="">
                    <Descriptions.Item label={deviceFields.imei.title}>{data.imei}</Descriptions.Item>
                    <Descriptions.Item label={deviceFields.curef.title}>{data.curef}</Descriptions.Item>
                    <Descriptions.Item label={deviceFields.custom_id.title}>{data.custom_id}</Descriptions.Item>
                    <Descriptions.Item label={deviceFields.activation_date.title}>{data.activation_date}</Descriptions.Item>
                    <Descriptions.Item label={"Last Online"}>{data.last_check_online}</Descriptions.Item>
                    <Descriptions.Item label={deviceFields.wifi_mac.title}>{data.wifi_mac}</Descriptions.Item> 
                </Descriptions> 
                ) : (<Empty />) }
                <Divider />
                <Table
                    dataSource={batteryList}
                    columns = {this.columns}
                />
            </>
        )
    }
}

export default SearchItem;